import React from 'react';
import { ArrowUpRight, ShoppingBag, Sparkles } from 'lucide-react';

interface ShopCardProps {
  href: string;
  imageSrc: string;
  badge: string;
  title: string;
  subtitle: string;
  ctaText: string;
}

const ShopCard: React.FC<ShopCardProps> = ({
  href,
  imageSrc,
  badge,
  title,
  subtitle,
  ctaText,
}) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="group relative block w-full rounded-3xl overflow-hidden art-card border border-brand-amber/30 shadow-xl transition-all duration-300 active:scale-[0.98]"
    >
      <div className="relative w-full h-56 md:h-64 rounded-[20px] overflow-hidden flex flex-col justify-between p-5 md:p-6 bg-slate-950">
        {/* Artwork Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-center transition-transform duration-700 ease-out group-hover:scale-105 opacity-75 group-hover:opacity-85"
          style={{ backgroundImage: `url(${imageSrc})` }}
        />

        {/* Dark Vignette Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/50 to-slate-950/20" />

        {/* Top Badge */}
        <div className="relative z-10 flex items-center justify-between">
          <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-slate-950/80 backdrop-blur-md border border-brand-amber/40 text-brand-amber text-xs font-bold uppercase tracking-wider">
            <Sparkles className="w-3.5 h-3.5 text-brand-amber" />
            <span>{badge}</span>
          </div>

          <div className="w-8 h-8 rounded-full bg-white/10 backdrop-blur-md flex items-center justify-center text-white group-hover:bg-brand-amber group-hover:text-slate-950 transition-colors">
            <ArrowUpRight className="w-4 h-4" />
          </div>
        </div>

        {/* Bottom Title & Action */}
        <div className="relative z-10 space-y-1.5">
          <p className="text-xs md:text-sm font-medium text-slate-300 tracking-wider uppercase">
            {subtitle}
          </p>
          <div className="flex flex-wrap items-center justify-between gap-3">
            <h3 className="text-2xl md:text-3xl font-extrabold text-white tracking-tight group-hover:text-brand-amber transition-colors font-heading">
              {title}
            </h3>
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-brand-amber hover:bg-amber-400 text-slate-950 font-bold text-sm shadow-md transition-colors shrink-0">
              <ShoppingBag className="w-4 h-4" />
              <span>{ctaText}</span>
            </span>
          </div>
        </div>
      </div>
    </a>
  );
};

export default ShopCard;
